// extracted by mini-css-extract-plugin
module.exports = {"MessagesPage":"MessagesPage_MessagesPage__1DNCZ","CreateNew":"MessagesPage_CreateNew__2Tkj7"};